import {useMessageComponents} from '../../../Conversation/MessageComponentContext';
import {
  StructuredContentCompat,
  StructuredContentCompatProps,
} from './StructuredContentCompat';

export function StructuredContentComponent({
  structuredContent,
  onComplete,
  isDone,
  messageId,
}: StructuredContentCompatProps) {
  const messageComponentRegistry = useMessageComponents();

  const StructuredComponent = messageComponentRegistry['structured-content'];

  if (StructuredComponent) {
    const Component = StructuredComponent as React.ComponentType<any>;
    return (
      <Component
        structuredContent={structuredContent}
        onComplete={onComplete}
        isDone={isDone}
        messageId={messageId}
      />
    );
  }

  return (
    <StructuredContentCompat
      structuredContent={structuredContent}
      onComplete={onComplete}
      isDone={isDone}
      messageId={messageId}
    />
  );
}
